import React from 'react'
import './index.css'

const EDIT_RATING_LABEL = 'Edit rating'
const DISLIKE_LABEL = 'DISLIKE'
const LIKE_LABEL = 'LIKE'

const CROSSED_ICON_URL = 'https://cdn.shopify.com/s/files/1/0569/9957/5718/files/crossed.png?v=1727892900'

const EditRatingBottomSheet = ({
  onLike,
  onDislike,
  label,
  onClose
}) => {
  return (
    <div className='edit-rating-bottom-overlay'>

      <div
        className='edit-rating-icon-crossed-container'

      >

        <div className='edit-rating-modal-header-item ' />

        <div className='edit-rating-label edit-rating-modal-header-item'>{label ?? EDIT_RATING_LABEL}</div>

        <div className='edit-rating-modal-header-item edit-rating-modal-header-item-end' onClick={onClose}>
          <img
            className='edit-rating-icon-crossed'
            src={CROSSED_ICON_URL}
          />
        </div>

      </div>

      <div className='edit-rating-buttons-container'>
        <button className='edit-rating-button-container' onClick={onDislike}>
          <div className='edit-rating-button-dislike'>
            <svg class='close-icon' xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M18.53 17.4698C18.823 17.7628 18.823 18.2378 18.53 18.5308C18.384 18.6768 18.192 18.7508 18 18.7508C17.808 18.7508 17.616 18.6778 17.47 18.5308L12 13.0608L6.52999 18.5308C6.38399 18.6768 6.19199 18.7508 5.99999 18.7508C5.80799 18.7508 5.61599 18.6778 5.46999 18.5308C5.17699 18.2378 5.17699 17.7628 5.46999 17.4698L10.94 11.9998L5.46999 6.52981C5.17699 6.23681 5.17699 5.76177 5.46999 5.46877C5.76299 5.17577 6.238 5.17577 6.531 5.46877L12.001 10.9388L17.471 5.46877C17.764 5.17577 18.239 5.17577 18.532 5.46877C18.825 5.76177 18.825 6.23681 18.532 6.52981L13.062 11.9998L18.53 17.4698Z' /></svg>
          </div>
          <div className='edit-rating-button-label-nope'>
            {DISLIKE_LABEL}
          </div>
        </button>

        <button className='edit-rating-button-container' onClick={onLike}>
          <div className='edit-rating-button-like'>
            <svg className='like-icon' width='24' height='22' viewBox='0 0 14 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path d='M3.66202 0.377633C3.25218 0.377633 2.81668 0.46123 2.36133 0.653042C0.371717 1.4906 -0.132144 3.59912 0.241666 5.20393C1.15835 9.14131 6.16392 11.3897 6.79432 11.6584C7.42472 11.3894 12.4305 9.13848 13.3468 5.20393C13.7206 3.59912 13.2167 1.49043 11.227 0.652865C9.28779 -0.163621 7.70714 0.978751 6.943 2.2049C6.87903 2.30815 6.70996 2.30815 6.64546 2.2049C6.06058 1.26674 4.99768 0.377633 3.66202 0.377633Z' fill='white' />
            </svg>
          </div>
          <div className='edit-rating-button-label-like'>
            {LIKE_LABEL}
          </div>
        </button>
      </div>
    </div>
  )
}

export default EditRatingBottomSheet
